import type { OrganizationMemoryDTO } from '@eriko/shared-types';
import { apiClient } from '../lib/api';
import { ENDPOINTS } from './endpoints';

export async function listMemory(): Promise<OrganizationMemoryDTO[]> {
  const res = await apiClient.get<OrganizationMemoryDTO[]>(ENDPOINTS.memory.list);
  return res.data;
}

export async function createMemory(
  content: string,
): Promise<OrganizationMemoryDTO & { deduplicated: boolean }> {
  const res = await apiClient.post<OrganizationMemoryDTO & { deduplicated: boolean }>(
    ENDPOINTS.memory.create,
    { content },
  );
  return res.data;
}

export async function deleteMemory(id: string): Promise<{ id: string }> {
  const res = await apiClient.delete<{ id: string }>(ENDPOINTS.memory.delete(id));
  return res.data;
}
